export default {
    SOMETHING_WENT_WRONG: 'Something went wrong!',
    TRY_AGAIN: 'Please try again later or feel free to contact us if the problem persists.',
};
